<template>
  <div class="help-tooltip-container">
    <slot
      name="default"
      :on="{ mouseenter: showHelp, mouseleave: hideHelp }"
    ></slot>
    <transition name="fade">
      <div v-if="active" class="help-tooltip">
        <img :src="pictures[locale]" alt="cheque" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      active: false,
      pictures: {
        es: require('../assets/spanish_cheque.png'),
        en: require('../assets/cheque.png'),
      },
    }
  },
  methods: {
    showHelp() {
      this.active = true
    },
    hideHelp() {
      this.active = false
    },
    toogleHelp() {
      this.active = !this.active
    },
  },
}
</script>

<style lang="postcss" scoped>
.help-tooltip-container {
  @apply tw-relative;
}

.help-tooltip {
  /* Base */
  @apply tw-absolute tw-block tw-z-10 tw-right-0;
  @apply tw-w-[270px] tw-h-[184px];
  @apply tw-bg-white;
  @apply tw-p-4 tw-rounded tw-border tw-border-primary;

  /* Desktop */
  @apply lg:tw-top-0 lg:tw-left-8 lg:tw-inline-block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
